var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":_vm.link,"width":"2560px","height":"1440px","frameBorder":"0","allow":"autoplay; fullscreen","allowFullScreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }